import { render, staticRenderFns } from "./super_admin.vue?vue&type=template&id=1ca161ce&scoped=true"
import script from "./super_admin.vue?vue&type=script&lang=js"
export * from "./super_admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca161ce",
  null
  
)

export default component.exports